export default "__VITE_ASSET__DTHbPuCi__ 1920w";